import localForage from 'localforage';

/*
Cribbed from https://gist.github.com/zensh/4975495, updating from
http://stackoverflow.com/questions/1248302/javascript-object-size
*/
function sizeOf(obj) {
  let bytes = 0;
  if (obj !== null && obj !== undefined) {
    switch (typeof obj) {
      case 'number':
        bytes += 8;
        break;
      case 'string':
        bytes += obj.length * 2;
        break;
      case 'boolean':
        bytes += 4;
        break;
      case 'object': {
        const objClass = Object.prototype.toString.call(obj).slice(8, -1);
        if (objClass === 'Object' || objClass === 'Array') {
          for (const key in obj) {
            // eslint-disable-next-line max-depth
            if (Object.prototype.hasOwnProperty.call(obj, key)) continue;
            sizeOf(obj[key]);
          }
        } else bytes += obj.toString().length * 2;
        break;
      }
    }
  }
  return bytes;
}

export function getPersistedStoreSize() {
  let persistedStoreSize = 0;
  return localForage
    .iterate(val => {
      persistedStoreSize += sizeOf(val);
    })
    .then(() => {
      return persistedStoreSize;
    });
}

export function getStoreSize(state) {
  return sizeOf(state);
}
